import { ResetPassword } from "shared/auth/resetPassword";
import { CenteredContainer } from "components/centeredContainer";
import { useAuthRoutes } from "shared/auth/useAuthRoutes";
import { useToast } from "shared/toast/useToast";

export default function ResetPasswordPage() {
  const { goToLoginPage } = useAuthRoutes();
  const { success } = useToast();
  function handleSuccess() {
    goToLoginPage();
    success("Your password is set. Please login again!", 100);
  }

  return (
    <CenteredContainer>
      <ResetPassword handleSuccess={handleSuccess} />
    </CenteredContainer>
  );
}
